import React from 'react';
import {useMatches, useLoaderData} from '@remix-run/react';
import type {
  Product,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import {Link} from 'components/Link';

//domains
import type {SanityProductQueryResponse} from '~/domains/product';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';
import {brandHref} from '~/lib/brandCollections';

export default function ProductDetailsVendor() {
  const matches = useMatches();
  const routeData = matches.find(
    (m) => m.id === 'routes/($lang)/products/$productHandle',
  )?.data;
  const product = routeData.product as Product & {
    selectedVariant?: ProductVariant;
  };
  const productSettings =
    routeData.productSettings as SanityProductQueryResponse['productSettings'];

  // const {collectionsForBreadcrumb} = useLoaderData<typeof loader>();
  // const productTypeQueryParms = new URLSearchParams({pf_pt_product_type: product.productType});
  // const closestCollection = collectionsForBreadcrumb[collectionsForBreadcrumb.length - 1]

  return (
    <div className="mt-[20px] flex flex-col justify-between space-y-3 lg:flex-row lg:space-x-4 lg:space-y-0">
      {/* product vendor/brand */}
      <div className="brand flex space-x-1">
        <span className="whitespace-nowrap font-medium">
          {productSettings?.product_settings_translations?.brand_label ??
            'Brand'}{' '}
          :
        </span>
        <Link to={brandHref(product.vendor)}>
          <span className="font-normal">{product.vendor}</span>
        </Link>
      </div>
      {/* product type */}
      {/* <div className="product-type flex space-x-1">
        <span className="whitespace-nowrap font-medium">
          {productSettings?.product_settings_translations?.product_type_label ??
            'Product Type'}{' '}
          :
        </span>
        <Link
          to={`/collections/${closestCollection.handle}?${productTypeQueryParms.toString()}`}
        >
          <span className="font-normal">{product.productType}</span>
        </Link>
      </div> */}
    </div>
  );
}
